import { gsap } from "../global/gsap";

const initHomeHighlights = (highlightsEl) => {
    const mediaSlides = highlightsEl.querySelectorAll(".js-media-item");
    const textEl = highlightsEl.querySelector(".js-text");
    const textSlides = highlightsEl.querySelectorAll(".js-text-item");
    const totalSlides = mediaSlides.length;

    const updateActiveSlide = (index) => {
        if (!mediaSlides[index] || !textSlides[index]) return;
        mediaSlides.forEach(el => el.classList.remove('is-active'));
        textSlides.forEach(el => el.classList.remove('is-active'));

        mediaSlides[index].classList.add('is-active');
        textSlides[index].classList.add('is-active');

        textEl.style.transform = `translateY(-${index * 33}%)`;
    }

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: highlightsEl,
            start: "bottom bottom",
            end: "top top+=200px",
            scrub: true,
            onUpdate: (self) => {
                let index = Math.floor(self.progress * totalSlides);
                if (index >= totalSlides) index = totalSlides - 1;
                if (index < 0) index = 0;

                if (highlightsEl.dataset.activeIndex !== index) {
                    updateActiveSlide(index);
                    highlightsEl.dataset.activeIndex = index;
                }
            },
        },
    });
};

export { initHomeHighlights as default };
